import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import SearchBar from '../../../elements/SearchBar/SearchBar3';

const ExhibitorsSearchBar = props => {
    const {event, i18n, filter, children, onOpenFilterScreen, disableFilterButton} = props,
        dispatch = useDispatch();

    const handleTextFilterChange = useCallback(text => dispatch(app.actions.exhibitors.setFilterText(event.id, text)), [event]),
        handleToggleFavoritesFilter = useCallback(
            () => dispatch(app.actions.exhibitors.setFilter(event.id, {...filter, favorites: !filter.favorites})),
            [filter, event]
        );

    return (
        <SearchBar
            value={filter.text || ''}
            i18n={i18n}
            favorites={filter.favorites}
            onFilterClick={onOpenFilterScreen}
            onTextChange={handleTextFilterChange}
            showEditIcon={!!_(filter.tags).values().flatten().value().length}
            disableFilterButton={disableFilterButton}
            onToggleFavorites={handleToggleFavoritesFilter}>
            {children}
        </SearchBar>
    );
};

export default ExhibitorsSearchBar;
